const state = () => ({
  isValid: false,
  fullName: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  fullName(state) {
    return state.fullName;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateFullName(state, payload) {
    state.fullName = payload;
  },
  resetStore(storeState) {
    Object.assign(storeState, state());
  }
};

const actions = {
  updateFullName({ commit }, payload) {
    commit('updateFullName', payload);
  }
};

export const fullName = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
